module.exports = __webpack_public_path__ + "static/media/emblem.38143fbf.svg";